import { Column, ColumnType } from '@scale/compass-shared/types';
import { CompassCardUI } from '@scale/compass-ui/types';
import {
  AutoReviewerCardShared,
  type AutoReviewerContextSchemaType,
  type AutoReviewerContext,
  type AutoreviewerResultsFilter,
  AUTOREVIEWER,
} from '@scale/genai-compass-shared/cards/autoreviewer';
import AutoreviewerResultsAdapterCardComponent from 'react-scale/corp/views/DataCompassCardsV2/adapter/AutoreviewerResultsAdapterCard/AutoreviewerResultsAdapterCardComponent';
import { faRobot } from '@fortawesome/pro-solid-svg-icons';

/** Input columns for Autoreviewer Results Adapter filtering. */
export const AUTOREVIEWER_RESULTS_INPUT_COLUMNS: Record<
  string,
  Column & { id: keyof AutoreviewerResultsFilter }
> = {
  reviewLevel: {
    id: 'reviewLevel',
    header: 'Attempted At Review Level',
    type: ColumnType.TEXT,
  },
};

const defaultContext: AutoReviewerContext = {
  cardType: AUTOREVIEWER,
  projectId: '',
  filter: {
    operator: 'and',
    filtersOrFilterGroups: [
      {
        column: AUTOREVIEWER_RESULTS_INPUT_COLUMNS.reviewLevel,
        condition: 'is',
        term: '',
      },
    ],
  },
};

export const AutoreviewerResultsAdapterCardInfo: CompassCardUI<AutoReviewerContextSchemaType> = {
  ...AutoReviewerCardShared,
  title: 'Autoreviewer Results',
  icon: 'robot',
  toolTip: 'View autoreviewer results for your project.',
  defaultContext,
  legacyComponent: AutoreviewerResultsAdapterCardComponent,
  button: {
    icon: faRobot,
  },
};
